<template>
  <div class="a-accordion__collapse ">
    <div class="a-accordion__tab" v-for="item in records">
      <div class="a-accordion__block">
        <template v-if="item.editable">
          <div class="a-accordion__block-content">
            <div class="a-container-form u-padding-bottom-0 a-width-100-percent">
              <div class="a-label a-label--w-280">{{$t('form.catalogs.catalog-type.regulations.paragraph')}}:</div>
              <input type="text" class="a-input a-input--w-380" v-model="item.code">
            </div>
            <div class="a-accordion__btn-tab a-accordion__btn-tab--justify-end a-width-auto u-margin-left-50">
              <button class="a-accordion__ok-btn" @click.prevent="onConfirmClick(item)">
                <img src="@/assets/img/static/tab-ok.svg">
              </button>
              <button class="a-accordion__clear-btn" @click.prevent="onCancelClick(item)">
                <img src="@/assets/img/static/tab-close.svg">
              </button>
            </div>
          </div>
          <div class="a-accordion__block-content">
            <div class="a-container-form u-padding-bottom-0 a-width-100-percent">
              <div class="a-label a-label--w-280">{{$t('form.catalogs.catalog-type.regulations.description')}}:</div>
              <textarea class="a-textarea a-input--w-380" rows=5 v-model="item.description"></textarea>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="a-accordion__block-content ">
            <div class="a-container-form u-padding-bottom-0 a-width-100-percent">
              <div class="a-label a-label--w-280">{{item.code}}</div>
              <p class="a-textarea a-textarea--disabled a-formatted-text">{{item.description}}</p>
            </div>
            <div class="a-accordion__btn-tab a-accordion__btn-tab--justify-end a-width-300">
              <button class="a-accordion__editing-btn" type="button" @click="$emit('editItem', item)">
                <img src="@/assets/img/static/b-icon_edit.svg">
                {{$t('buttons.modify')}}
              </button>
              <button class="a-accordion__remove-btn" type="button" @click="$emit('deleteItem', item)">
                <img src="@/assets/img/static/trashcan.svg">
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from '@/validators'
  import DatePicker from 'vuejs-datepicker'
  import { ru, en } from 'vuejs-datepicker/dist/locale'

  export default {
    props: {
      items: Array,
      isNew: Boolean
    },

    components: {
      DatePicker
    },

    data: () => ({
      lang: ru,
    }),

    computed: {
      records() {
        return this.items;
      }
    },

    methods: {
      onConfirmClick(item) {
        if (!required(item.code) || !required(item.description)) {
          this.$set(item, 'error', true);
          return;
        }

        this.$set(item, 'error', false);
        this.$emit('confirmEditable', item);
      },

      onCancelClick(item) {
        this.$emit('cancelEditable', item);
      }
    }
  }
</script>

<style scoped>

</style>
